const floaters = [
  { text: "好活", pos: "left-[8%] top-[22%]", delay: "0s" },
  { text: "蹲个后续", pos: "left-[70%] top-[30%]", delay: "1.2s" },
  { text: "全程高能", pos: "left-[15%] top-[58%]", delay: "2.4s" },
  { text: "笑不活了", pos: "left-[64%] top-[64%]", delay: "0.8s" },
  { text: "细节来了", pos: "left-[46%] top-[18%]", delay: "1.8s" },
];

const stats = [
  { num: "28", label: "今日现场" },
  { num: "12.6万", label: "实时在线" },
  { num: "93万", label: "今日弹幕" },
  { num: "3分", label: "热点热到上榜" },
];

export default function Hero() {
  return (
    <section id="top" className="relative overflow-hidden">
      {/* 背景光晕 */}
      <div className="pointer-events-none absolute inset-0 -z-10">
        <div className="absolute -left-32 -top-40 h-[480px] w-[480px] rounded-full bg-orange-600/20 blur-[130px]" />
        <div className="absolute right-0 top-1/3 h-[420px] w-[420px] rounded-full bg-amber-500/10 blur-[120px]" />
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_0%,rgba(249,115,22,0.12),transparent_60%)]" />
      </div>

      <div className="mx-auto flex max-w-7xl flex-col items-center px-4 pb-20 pt-40 text-center md:px-6 md:pt-48">
        <div className="mb-6 flex items-center gap-2 rounded-full border border-orange-500/30 bg-orange-500/10 px-4 py-1.5 text-xs font-medium text-orange-300">
          <span className="live-dot h-2 w-2 rounded-full bg-red-500" />
          正在实时聚合全网热议
          <span className="hidden sm:inline">· 新热点 3 分钟前上榜</span>
        </div>

        <h1 className="text-4xl font-black leading-[1.15] tracking-tight text-white md:text-6xl md:leading-[1.12]">
          全网热点
          <span className="mx-2 inline-flex items-center rounded-2xl bg-gradient-to-r from-orange-500 to-amber-400 px-3 py-1 text-white md:px-4 md:py-2">
            蹲在现场
          </span>
          <br />
          一起看才够味
        </h1>

        <p className="mt-6 max-w-2xl text-base leading-relaxed text-stone-300 md:text-lg">
          99吃瓜为你一站式聚合 <strong className="font-semibold text-orange-300">直播讨论</strong>、
          <strong className="font-semibold text-orange-300">连麦现场</strong>、<strong className="font-semibold text-orange-300">弹幕合集</strong> 与
          <strong className="font-semibold text-orange-300">主播锐评</strong>。热门话题一出就有人开播陪看，全网反应视频随手能刷。
        </p>

        <div className="mt-9 flex flex-col items-center gap-3 sm:flex-row">
          <a
            href="#now"
            className="inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-orange-500 px-7 py-3.5 text-base font-semibold text-stone-950 shadow-[0_10px_40px_-10px_rgba(249,115,22,0.7)] transition-transform hover:-translate-y-0.5 hover:bg-orange-400"
          >
            <i className="ri-play-fill" />
            进入今日现场
          </a>
          <a
            href="#danmaku"
            className="inline-flex items-center gap-2 whitespace-nowrap rounded-full border border-white/15 bg-white/5 px-7 py-3.5 text-base font-medium text-stone-100 transition-colors hover:border-orange-400/50 hover:text-orange-300"
          >
            <i className="ri-chat-3-line" />
            去刷弹幕
          </a>
        </div>

        {/* 数据条 */}
        <dl className="mt-14 grid w-full max-w-3xl grid-cols-2 gap-4 md:grid-cols-4">
          {stats.map((s) => (
            <div
              key={s.label}
              className="rounded-2xl border border-white/10 bg-white/[0.04] px-4 py-5 backdrop-blur-sm"
            >
              <dt className="order-2 mt-1 block text-xs text-stone-400">{s.label}</dt>
              <dd className="font-display text-2xl font-bold text-white md:text-3xl">{s.num}</dd>
            </div>
          ))}
        </dl>
      </div>

      {/* 飘动弹幕 */}
      <div className="pointer-events-none absolute inset-0 hidden md:block" aria-hidden>
        {floaters.map((f) => (
          <span
            key={f.text}
            style={{ animationDelay: f.delay }}
            className={`animate-danmaku absolute ${f.pos} rounded-full border border-orange-500/20 bg-white/[0.04] px-4 py-1.5 text-sm text-orange-200/80 backdrop-blur-sm`}
          >
            {f.text}
          </span>
        ))}
      </div>
    </section>
  );
}